import React from 'react';

const CsvFileInput = ({label, onFileLoad, isLoading}) => {

    return (
        <div>
            <label htmlFor={isLoading ? "" : "csv-file-input"} className="btn btn-secondary">
                <i className={isLoading ?
                    "mr-2 fa fa-spinner fa-spin" :
                    "mr-2 fa fa-upload"}/>
                {label}
            </label>
            <input
                id="csv-file-input"
                className="d-none"
                accept=".csv"
                type="file"
                onChange={onFileLoad}
                onClick={event => event.target.value = null}
            />
        </div>
    );
};
export default CsvFileInput;


// WEBPACK FOOTER //
// ./src/components/Common/CsvFileInput.js